import CrudCustom from '../../../libs/custom/CrudCustom';

let KodeObjekPajakService = new CrudCustom('/kode-objek-pajaks');
export default KodeObjekPajakService;
